module.exports = __webpack_public_path__ + "img/40.cd90f3f4.png";